import "./App.scss";
import Board from "./containers/Board";

function App() {
  return (
    <div className="app">
      <Board />
    </div>
  );
}

export default App;
